import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";

export class Cart extends Phaser.GameObjects.Sprite {
    isFixed: boolean;

    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name);
        this.name = ob.name;
        this.isFixed = false;
        this.setDepth(2);

        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this);
        this.scene.add.existing(this);
    }
}




// WEBPACK FOOTER //
// ./src/games/RideMechanicGame/objects/Cart.ts